<template>
  <WorkspaceFinanceiroServicosPage v-if="isServicos" />
  <WorkspaceFinanceiroPage v-else />
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useGlobalWorkspaces } from '@/composables/useGlobalWorkspaces'
import { isServicosWorkspace } from '@/utils/workspaceTipo'
import WorkspaceFinanceiroPage from './WorkspaceFinanceiroPage.vue'
import WorkspaceFinanceiroServicosPage from './WorkspaceFinanceiroServicosPage.vue'

const route = useRoute()
const { currentWorkspace, workspaces } = useGlobalWorkspaces()

const workspace = computed(() => {
  if (currentWorkspace.value) return currentWorkspace.value
  const id = route.params.id
  return workspaces.value.find(w => String(w.id) === String(id)) || null
})

const isServicos = computed(() => isServicosWorkspace(workspace.value))
</script>
